import { Fighter } from '../../domain/models/fighter.model';
import {
  RetrieveFighters,
  RetrieveFightersFailure,
  RetrieveFightersPayload,
  RetrieveFightersSuccess,
  RETRIEVE_FIGHTERS,
  RETRIEVE_FIGHTERS_FAILURE,
  RETRIEVE_FIGHTERS_SUCCESS,
} from './fighter.action.type';

export const retrieveFighters = (
  payload: RetrieveFightersPayload,
): RetrieveFighters => ({
  type: RETRIEVE_FIGHTERS,
  payload,
});

export const retrieveFightersSuccess = (
  payload: Fighter[],
): RetrieveFightersSuccess => ({
  type: RETRIEVE_FIGHTERS_SUCCESS,
  payload,
});

export const retrieveFightersFailure = (
  error: string,
): RetrieveFightersFailure => ({
  type: RETRIEVE_FIGHTERS_FAILURE,
  payload: error,
});
